import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../assets/css/Bookmark.css";
import { Thumbnail } from "../components";

export default function Bookmark() {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const userId = sessionStorage.getItem("user_id");
  const [bookmarkRec, setBookmark] = useState([]); // fetched data
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  // ✅ Fetch data from API
  useEffect(() => {
    axios
      .post(`${BASE_URL}/access-control/api/list-bookmarked/`, {
        userId: userId,
      })
      .then((res) => {
        const apiData = res.data.data || [];
        const validData = apiData.filter(
          (item) => item.title && item.title !== ""
        );
        setBookmark(validData);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        setLoading(false);
      });
  }, []);

  // ✅ Filter logic
  const filtered = useMemo(() => {
    return bookmarkRec.filter((p) => {
      if (
        search &&
        !`${p.title}`.toLowerCase().includes(search.toLowerCase())
      ) {
        return false;
      }
      return true;
    });
  }, [bookmarkRec, search]);


  const itemsPerPage = 9; // cards per page
  const [currentPage, setCurrentPage] = useState(1);

  // total pages
  const totalPages = Math.ceil(filtered.length / itemsPerPage);

  // slice data for current page
  const paginatedData = filtered.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [filtered]);

  const resetFilters = () => {
    setSearch("");
  };

  const handleDeleteBookmark = async (bookmarkId) => {
    try {
      await axios.post(
        "https://resourcehub.nitorinfotech.com/access-control/api/delete-bookmarked/",
        {
          BookmarkId: bookmarkId,
        }
      );

      // ✅ Remove from UI instantly
      setBookmark((prev) =>
        prev.filter((item) => item.id !== bookmarkId)
      );

    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  return (
    <div className="home-page">
      {/* ===== Hero Section ===== */}
      {/* <section className="banner hero-banner">
        <div className="banner-overlay"></div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 col-sm-12 left-section">
              <h1 className="heading">
                Discover Our Team’s <br /> Today
              </h1>
              
            </div>
            <div className="col-md-8 col-sm-8 right-section text-center">
              <input
                type="text"
                className="form-control search-input"
                placeholder="Search Collateral..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
        </div>
      </section> */}
      <section className="data-sec">
        {/* ===== Cards Section ===== */}
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 ">
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <div id="bookmark-card" className="row g-4">
                  {filtered.length === 0 ? (
                    <div className="col-12 text-center py-4">
                      <div className="alert alert-secondary">
                        No results found. Try changing filters.
                      </div>
                    </div>
                  ) : (
                    paginatedData.map((reqData, i) => (
                      <div
                        className="col-12 col-md-3 col-lg-3"
                        key={reqData.id || i}
                        onClick={() => {
                          const url = reqData.site_url;

                          if (url.startsWith("http")) {
                            window.location.href = url;
                          } else {
                            navigate(url);
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >

                        <div className="card shadow-sm rounded-3">
                          <div className="card-body row">
                            <div className="col-12 col-md-12 col-lg-12">
                              <Thumbnail
                                driveId={reqData.drive_id}
                                itemId={reqData.item_id}
                                title={reqData.title}
                              />
                              <h5 className="card-title">{reqData.title}</h5>
                              <div className="tags">
                                <i
                                  className="fa fa-times"
                                  aria-hidden="true"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteBookmark(reqData.id);
                                  }}
                                  style={{ cursor: "pointer" }}
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))

                  )}
                  {totalPages > 1 && (
                    <div className="d-flex justify-content-center mt-4">
                      <nav>
                        <ul className="pagination">

                          {/* Previous */}
                          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <button
                              className="page-link pagination-action-btn"
                              onClick={() => setCurrentPage(prev => prev - 1)}
                            >
                              <i className="fa fa-arrow-circle-left"></i>
                            </button>
                          </li>

                          {/* Page Numbers */}
                          {[...Array(totalPages)].map((_, index) => (
                            <li
                              key={index}
                              className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                            >
                              <button
                                className="page-link page-num"
                                onClick={() => setCurrentPage(index + 1)}
                              >
                                page {index + 1}
                              </button>
                            </li>
                          ))}

                          {/* Next */}
                          <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                            <button
                              className="page-link pagination-action-btn"
                              onClick={() => setCurrentPage(prev => prev + 1)}
                            >
                              <i className="fa fa-arrow-circle-right"></i>
                            </button>
                          </li>

                        </ul>
                      </nav>
                    </div>
                  )}

                </div>
              )}
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}
